'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _size2 = require('lodash/size');

var _size3 = _interopRequireDefault(_size2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _utils = require('../utils');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function accessors(target) {
  target.accessors = (0, _extends3.default)({}, target.accessors, {
    data: function data(_data) {
      return (0, _get3.default)(_data, '[0].datapoints', []);
    },
    symbolValues: function symbolValues(data) {
      return (0, _get3.default)(data, '[0].symbolValues', []);
    },
    marker: function marker(options, datum) {
      var markers = options.symbol.markers;
      var index = datum.marker % (0, _size3.default)(markers);
      return markers[index];
    },
    markerColor: function markerColor(options, keyword, datum) {
      var marker = target.accessors.marker(options.serie, datum);
      var color = (0, _get3.default)(marker, 'style.' + keyword, null);
      return color === null || target.accessors.isFocused(datum) ? utils.getColor(options.serie, target.accessors.focusData(datum)) : color;
    },
    markerStrokeWidth: function markerStrokeWidth(options, datum) {
      var marker = target.accessors.marker(options.serie, datum);
      var defaultSW = (0, _get3.default)(options, 'serie.symbol.markerDefaultStrokeWidth');
      return (0, _get3.default)(marker, 'style.strokeWidth', defaultSW);
    },
    markerRotate: function markerRotate(options, datum) {
      var marker = target.accessors.marker(options.serie, datum);
      return (0, _get3.default)(marker, 'rotate', 0);
    },
    yRange: function yRange(base, axis) {
      return base.xScale.rangeExtent();
    },
    xTicks: function xTicks(base, axis) {
      return axis.xAxis.scale().domain();
    }
  });
}
exports.default = accessors;